// MessageReadStatus component for single (sent) and double (read) checkmark indicators
import React, { FC } from 'react';
import { ReactComponent as SingleCheckmarkIcon } from 'src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-single-check.svg';
import { ReactComponent as DoubleCheckmarkIcon } from 'src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-double-check.svg';

interface MessageReadStatusProps {
  isRead: boolean;
  isSentByTrainer?: boolean;
}

export const MessageReadStatus: FC<MessageReadStatusProps> = (props: MessageReadStatusProps) => {
  const { isRead, isSentByTrainer } = props;
  if (!isSentByTrainer) return null;

  return (
    <span
      className={`message-read-status ${isRead ? 'read' : 'sent'}`}
      aria-label={isRead ? 'Message read by recipient' : 'Message sent'}
      title={isRead ? 'Read' : 'Delivered'}
    >
      {isRead ? (
        <DoubleCheckmarkIcon className="checkmark-svg double-check" />
      ) : (
        <SingleCheckmarkIcon className="checkmark-svg single-check" />
      )}
    </span>
  );
};

MessageReadStatus.displayName = 'MessageReadStatus';
